import { useFormikContext } from 'formik'
import { ChangeEvent } from 'react'
import { useTranslation } from 'react-i18next'

import { TextInputWithHelper, HelperWrapper } from 'src/components'
import { IStepForm } from 'src/types'

interface IProps {
  isDisabled?: boolean
}

export const CodeInput = ({ isDisabled }: IProps) => {
  const [t] = useTranslation()
  const { values, errors, setFieldValue } = useFormikContext<IStepForm>()

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value

    if (value.length === 1) {
      setFieldValue('code', `S-${value}`)
      return
    }

    if (value.length <= 2) {
      setFieldValue('code', '')
      return
    }

    if (value.startsWith('S-')) {
      setFieldValue('code', value)
      return
    }

    setFieldValue('code', `S-${value}`)
  }

  return (
    <TextInputWithHelper
      disabled={isDisabled}
      inputName="code"
      handleChange={handleChange}
      value={values.code}
      error={errors.code ? t(errors.code + (errors.code.includes(' ') ? '' : '.v')) : ''}
      inputPlaceholder={t('steps-form-code-input-placeholder.v')}
      inputUpperLabel={<HelperWrapper t={'steps-form-code-input-label'} isInputLable isMandatory />}
    />
  )
}
